<div *ngIf="czyZaladowanoDane">
  <!-- Naglowek - Desktop -->
  <div class="container--main d-none d-md-block">
    <div class="d-flex py-4 justify-content-center">
      <h2 class="page-title">Moje raporty godzinowe</h2>
    </div>
  </div>

  <!-- Naglowek - Mobile -->
  <div class="container d-md-none">
    <div class="d-flex py-3 justify-content-center">
      <h2 class="page-title">Moje raporty godzinowe</h2>
    </div>
  </div>

  <!-- Panel filtrow - Desktop -->
  <div class="container-fluid d-none d-md-block">
    <div class="panel-filtrow py-3 mb-3">
      <div class="filtry-wiersz">
        <!-- Projekty multi-select -->
        <div class="filtr-projekty">
          <label>Projekty</label>
          <ng-select
            [searchable]="true"
            [clearable]="true"
            [multiple]="true"
            [items]="projekty"
            [(ngModel)]="wybraneProjektyId"
            bindLabel="nazwa"
            bindValue="id"
            [closeOnSelect]="false"
            notFoundText="Brak projektów"
            (change)="zastosujFiltry()"
          >
            <ng-template ng-multi-label-tmp let-items="items">
              <span class="ng-value-label-count">Wybrano: {{ items.length }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$">
              <input type="checkbox" [checked]="item$.selected" class="ng-option-checkbox" />
              <span>{{ item.nazwa }}</span>
            </ng-template>
            <ng-template ng-header-tmp>
              <div class="ng-select-header-actions">
                <button type="button" class="btn-select-all" (click)="zaznaczWszystkieProjekty()">Zaznacz wszystko</button>
                <button type="button" class="btn-clear-all" (click)="odznaczWszystkieProjekty()">Odznacz wszystko</button>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <!-- Zakres dat -->
        <div class="filtr-daty">
          <label>Zakres dat</label>
          <app-zakres-dat
            [dataOd]="dataOd"
            [dataDo]="dataDo"
            (zakresZmieniony)="naZakresZmieniony($event)"
          ></app-zakres-dat>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela godzin - Desktop -->
  <div class="container-fluid d-none d-md-block">
    <div class="box__scroll">
      <div class="tableFixHead tableFixHead--scrollable">
        <table class="table">
          <!-- Naglowek -->
          <thead>
            <tr>
              <th class="sticky-col sticky-col-1">Lp.</th>
              <th class="sticky-col sticky-col-2">
                Projekt
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="kierunekSortowania.projekt"
                  (click)="zmienSortowanie('projekt')"
                ></button>
              </th>
              <th *ngFor="let data of daty" class="kolumna-data">
                <span>{{ data.dataFormatowana }}</span>
              </th>
              <th class="sticky-col-right">
                SUMA
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="kierunekSortowania.suma"
                  (click)="zmienSortowanie('suma')"
                ></button>
              </th>
            </tr>
          </thead>

          <!-- Cialo tabeli -->
          <tbody>
            <tr *ngFor="let raport of raportyWyswietlane; let i = index">
              <td class="sticky-col sticky-col-1">{{ i + 1 }}</td>
              <td class="sticky-col sticky-col-2">{{ raport.projektNazwa }}</td>
              <td *ngFor="let data of daty" class="kolumna-data">
                <span
                  class="godziny-value"
                  [ngClass]="{ 'godziny-puste': pobierzGodzinyDnia(raport, data.data) === null }"
                >
                  {{
                    pobierzGodzinyDnia(raport, data.data) !== null
                      ? pobierzGodzinyDnia(raport, data.data)
                      : '-'
                  }}
                </span>
              </td>
              <td class="sticky-col-right suma-pracownika">
                {{ obliczSumePracownika(raport) }}
              </td>
            </tr>
          </tbody>

          <!-- Stopka z sumami -->
          <tfoot>
            <tr class="wiersz-suma">
              <td class="sticky-col sticky-col-1"></td>
              <td class="sticky-col sticky-col-2 suma-label">SUMA</td>
              <td *ngFor="let data of daty" class="kolumna-data suma-dnia">
                {{ obliczSumeDnia(data.data) }}
              </td>
              <td class="sticky-col-right suma-calkowita">
                {{ obliczSumeCalkowita() }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Paginacja - Desktop -->
    <div
      class="paginate float-right d-flex align-items-center pt-4 pb-2 pt-lg-2 mt-1"
      *ngIf="czySaWynikiNaLiscie(raportyWyswietlane)"
    >
      <div>Pokaz wyniki</div>
      <select
        class="paginate__select mx-2"
        [(ngModel)]="rozmiarTabeli"
        (change)="zmienRozmiarTabeli()"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
  </div>

  <!-- Wersja mobilna -->
  <div class="container-fluid d-md-none pb-5">
    <!-- Panel filtrow - Mobile -->
    <div class="panel-filtrow-mobile mb-3">
      <!-- Projekty multi-select -->
      <div class="filtr-mobile">
        <label>Projekty</label>
        <ng-select
          [searchable]="true"
          [clearable]="true"
          [multiple]="true"
          [items]="projekty"
          [(ngModel)]="wybraneProjektyId"
          bindLabel="nazwa"
          bindValue="id"
          [closeOnSelect]="false"
          notFoundText="Brak projektów"
          (change)="zastosujFiltry()"
        >
          <ng-template ng-multi-label-tmp let-items="items">
            <span class="ng-value-label-count">Wybrano: {{ items.length }}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input type="checkbox" [checked]="item$.selected" class="ng-option-checkbox" />
            <span>{{ item.nazwa }}</span>
          </ng-template>
          <ng-template ng-header-tmp>
            <div class="ng-select-header-actions">
              <button type="button" class="btn-select-all" (click)="zaznaczWszystkieProjekty()">Zaznacz wszystko</button>
              <button type="button" class="btn-clear-all" (click)="odznaczWszystkieProjekty()">Odznacz wszystko</button>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Zakres dat -->
      <div class="filtr-mobile">
        <label>Zakres dat</label>
        <app-zakres-dat
          [dataOd]="dataOd"
          [dataDo]="dataDo"
          (zakresZmieniony)="naZakresZmieniony($event)"
        ></app-zakres-dat>
      </div>
    </div>

    <!-- Karty projektow (read-only) -->
    <div class="karty-pracownikow">
      <div
        class="karta-pracownika"
        *ngFor="let raport of raportyWyswietlane; let i = index"
      >
        <div class="karta-header">
          <span class="karta-lp">{{ i + 1 }}.</span>
          <div class="karta-info">
            <span class="karta-nazwa">{{ raport.projektNazwa }}</span>
          </div>
          <span class="karta-suma"
            >Suma: {{ obliczSumePracownika(raport) }}h</span
          >
        </div>
        <div class="karta-dni">
          <div class="karta-dzien" *ngFor="let data of daty">
            <span class="dzien-data">{{ data.dataFormatowana }}</span>
            <span
              class="dzien-godziny-value"
              [ngClass]="{ 'godziny-puste': pobierzGodzinyDnia(raport, data.data) === null }"
            >
              {{
                pobierzGodzinyDnia(raport, data.data) !== null
                  ? pobierzGodzinyDnia(raport, data.data)
                  : '-'
              }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginacja - Mobile -->
    <div
      class="paginate float-right d-flex align-items-center pb-2 pt-lg-4 mt-3"
      *ngIf="czySaWynikiNaLiscie(raportyWyswietlane)"
    >
      <div>Pokaz wyniki</div>
      <select
        class="paginate__select mx-2"
        [(ngModel)]="rozmiarTabeli"
        (change)="zmienRozmiarTabeli()"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
  </div>

  <!-- Przyciski na dole strony -->
  <div class="bootom__buttons px-4 d-none d-md-block" *ngIf="czyZaladowanoDane">
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn__blue" (click)="eksportujDane()">
        Eksportuj dane
      </button>
    </div>
  </div>

  <!-- Przycisk mobile -->
  <div class="d-md-none px-3 pb-4" *ngIf="czyZaladowanoDane">
    <button class="btn__primary w-100" (click)="eksportujDane()">
      Eksportuj dane
    </button>
  </div>
</div>
